import btn1 from "@public/images/h-1.png";
import btn2 from "@public/images/h-2.png";
import btn3 from "@public/images/h-3.png";
import btn4 from "@public/images/h-4.png";
import btn5 from "@public/images/h-5.png";
import btn6 from "@public/images/h-6.png";
import btn11 from "@public/images/h-11.png";
import btn21 from "@public/images/h-21.png";
import btn31 from "@public/images/h-31.png";
import btn41 from "@public/images/h-41.png";
import btn51 from "@public/images/h-51.png";
import btn61 from "@public/images/h-61.png";
export const compKindOptions = [
  {
    value: "010",
    label: "外商独资/外企办事处",
  },
  {
    value: "020",
    label: "中外合营(合资/合作)",
  },
  {
    value: "030",
    label: "私营/民营企业",
  },
  {
    value: "040",
    label: "国有企业",
  },
  {
    value: "050",
    label: "国内上市公司",
  },
  {
    value: "060",
    label: "政府机关/非盈利机构",
  },
  {
    value: "070",
    label: "事业单位",
  },
  {
    value: "999",
    label: "其它",
  },
];
export const compScaleOptions = [
  {
    value: "010",
    label: "1-49人",
  },
  {
    value: "020",
    label: "50-99人",
  },
  {
    value: "030",
    label: "100-499人",
  },
  {
    value: "040",
    label: "500-999人",
  },
  {
    value: "050",
    label: "1000-2000人",
  },
  {
    value: "060",
    label: "2000-5000人",
  },
  {
    value: "070",
    label: "5000-10000人",
  },
  {
    value: "080",
    label: "10000人以上",
  },
];
export const filterComps = [
  {
    name:'船舶海工产业',
    url: btn1,
    urlActive: btn11,
    comps:[
      13223897,
      9377067,
      8040756,
      7856188,
      8532100
    ]
  },
  {
    name:'高端纺织产业',
    url: btn2,
    urlActive: btn21,
    comps:[
      12250035,
      8557151,
      13716797,
      8296610,
      8043920,
      9135893,
      8464948
    ]
  },
  {
    name:'高端装备产业',
    url: btn3,
    urlActive: btn31,
    comps: [
      8435236,
      2628866,
      13240295,
      13326337,
      13157905,
      9516092,
      7921306
    ]
  },
  {
    name:'新材料产业',
    url: btn4,
    urlActive: btn41,
    comps:[
      9244705,
      13716797,
      13443149,
      8304674,
      12914205,
      8173716,
      9167350
    ]
  },
  {
    name:'新能源产业',
    url: btn5,
    urlActive: btn51,
    comps:[
      12254849,
      8914807,
      8183821,
      12439701,
      12304591
    ]
  },
  {
    name:'新一代信息技术产业',
    url: btn6,
    urlActive: btn61,
    comps:[
      7984762,
      9873003,
      8360675,
      12369067,
      7958488,
      12525113,
      13036559
    ]
  }
]